// Global session guard: every API call in this app goes through plain
// `fetch`. The backend issues a short-lived access token (30 min) plus a
// longer-lived refresh token — this file is what makes that invisible to
// the user: on a 401 "token_not_valid" response, it silently exchanges the
// refresh token for a new access token and retries the original request
// once. Only if that refresh itself fails (refresh token also expired, or
// missing) does it fall back to a clean logout — matching what Header.js's
// manual "Logout" button does — instead of leaking a raw JSON error.
//
// axios calls get the same treatment via axiosSessionGuard.js, sharing the
// refresh/logout logic in tokenRefresh.js so a mixed burst of fetch+axios
// 401s dedupes into one refresh attempt.
import { refreshAccessToken, forceLogout } from './tokenRefresh';

const originalFetch = window.fetch.bind(window);

window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401 && localStorage.getItem('access_token')) {
        let data = null;
        try { data = await response.clone().json(); } catch (e) { /* not JSON */ }

        if (data && data.code === 'token_not_valid') {
            const refreshed = await refreshAccessToken();
            if (refreshed) {
                const [url, options = {}] = args;
                return originalFetch(url, {
                    ...options,
                    headers: {
                        ...(options.headers || {}),
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                });
            }
            forceLogout();
        }
    }

    return response;
};
